import React from 'react'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import { CREATE_STORY_FORM_NAME as FORM_NAME } from 'app/constants/activities'

import ToggleBox from 'app/components/ToggleBox'
// @ts-ignore
import AddToFavotites from 'app/domains/common/AddToFavorites'
// @ts-ignore
import StoriesActiveIcon from 'app/components/SVGS/StoriesActiveIcon'

import NoteQuotesStoryForm from './NoteQuotesStoryForm'

import { INoteQuotesProps } from './interface';

import './style.scss'
const baseClass = 'note-quotes'

const NoteQuotes: React.FC<INoteQuotesProps> = ({
  t,
  className,
  onRequestClose,
  activityDay,
  proTrackName = 'ProTrack',
  proQuote,
  proQuoteAuthor,
  description,
  question,
  activityTitle,
  activityId,
  userActivityId,
  isActivityFavorite,
  onCloseDotPopover,
  onOpenDotPopover,
  isModal,
  isShowStoryForm,
}) => (<div
  className={cn(`${baseClass}`, {
    [className]: className,
  })}
  onMouseLeave={onCloseDotPopover}
  onMouseEnter={onOpenDotPopover}
>
  <div className={`${baseClass}__header`}>
    <div className={`${baseClass}__header-block`}>
      <span className={`${baseClass}__date`}>{`${t('Day')} ${activityDay}`}</span>
        | <span className={`${baseClass}__protrack-name`}>{proTrackName}</span>
      {isModal && (
        <span className={`${baseClass}__cross`} onClick={() => onRequestClose()}>
          &times;
        </span>
      )}
    </div>
    {activityId && (
      <div className={`${baseClass}__header-block`}>
        <AddToFavotites activityId={activityId} highlightFavoriteIcon={isActivityFavorite} />
      </div>
    )}
  </div>
  <div className={`${baseClass}__body`}>
    {activityTitle && <h3 className={`${baseClass}__title`}>{activityTitle}</h3>}
    {description && <p className={`${baseClass}__paragraf`} dangerouslySetInnerHTML={{ __html: description }} />}
    {isShowStoryForm && (
      <NoteQuotesStoryForm
        className={`${baseClass}__story-form`}
        form={`${FORM_NAME}${userActivityId}`}
        activityId={activityId}
        userActivityId={userActivityId}
        question={
          question && (
            <span>
              <StoriesActiveIcon className={`${baseClass}__story-icon`} />
              {question}
            </span>
          )
        }
      />
    )}
  </div>
  <div className={`${baseClass}__footer`}>
    <ToggleBox contentLabel="Quote" custom>
      <p className={`${baseClass}__quote-text`}>{proQuote}</p>
      <div className={`${baseClass}__quote-philosof`}>- {proQuoteAuthor}</div>
    </ToggleBox>
  </div>
</div>
  )

export default withTranslation('user')<any>(NoteQuotes)
